import React from 'react';
import Underline from '../img/underline.webp';

export default function NewsHeading() {
    return (
        <section id='news'>
            <div className='mt-20 mb-20'>
                    <h1 class="text-5xl text-center font-bold max-md:text-5xl max-md:text-center max-sm:text-4xl" style={{color:"#118C5F"}}>LATEST NEWS</h1>
                    <div className='flex justify-center mt-5'>
                        <img src={Underline} alt="about"/>
                    </div>
            </div>
        </section>
    )   
}
